import productionSiteNotesQueries from '@/api/modules/productionSiteNotesQueries'
import { t } from '@/i18n'
import { notificationService } from '@/services/notificationService'
import { handleApiError } from '@/utils/apiHelpers'

class ProductionSiteNotesService {
    /**
     * @param {string | { limit?: number | null | undefined, productionSiteId?: number | null | undefined, unreadById?: number | null | undefined } | undefined} [queryOrFilters]
     */
    async fetchProductionSiteNotes(queryOrFilters) {
        try {
            return await productionSiteNotesQueries.fetchProductionSiteNotes(queryOrFilters)
        } catch (error) {
            handleApiError(error, t('notes.notifications.fetchNotesError'))
            throw error
        }
    }

    async fetchProductionSiteNote(id) {
        try {
            return await productionSiteNotesQueries.fetchProductionSiteNote(id)
        } catch (error) {
            handleApiError(error, t('notes.notifications.fetchNoteError'))
            throw error
        }
    }

    async confirmProductionSiteNote(id) {
        try {
            const response = await productionSiteNotesQueries.confirmProductionSiteNote(id)
            notificationService.success(t('notes.notifications.noteConfirmed'))
            return response
        } catch (error) {
            handleApiError(error, t('notes.notifications.noteConfirmError'))
            throw error
        }
    }

    async createProductionSiteNote(noteData) {
        try {
            const response = await productionSiteNotesQueries.createProductionSiteNote(noteData)
            notificationService.success(t('notes.notifications.noteCreated'))
            return response
        } catch (error) {
            handleApiError(error, t('notes.notifications.noteCreationError'))
            throw error
        }
    }

    async updateProductionSiteNote(noteData) {
        try {
            const response = await productionSiteNotesQueries.updateProductionSiteNote(noteData.id, noteData)
            notificationService.success(t('notes.notifications.noteUpdated'))
            return response
        } catch (error) {
            handleApiError(error, t('notes.notifications.noteUpdateError'))
            throw error
        }
    }

    async deleteProductionSiteNote(id) {
        try {
            const response = await productionSiteNotesQueries.deleteProductionSiteNote(id)
            notificationService.success(t('notes.notifications.noteDeleted'))
            return response
        } catch (error) {
            handleApiError(error, t('notes.notifications.noteDeleteError'))
            throw error
        }
    }

    async createProductionSiteNoteComment(commentData) {
        try {
            const response = await productionSiteNotesQueries.createProductionSiteNoteComment(commentData)
            notificationService.success(t('notes.notifications.commentCreated'))
            return response
        } catch (error) {
            handleApiError(error, t('notes.notifications.commentCreationError'))
            throw error
        }
    }

    async fetchUnreadProductionSiteNotes(userId) {
        try {
            return await productionSiteNotesQueries.fetchUnreadProductionSiteNotes(userId)
        } catch (error) {
            handleApiError(error, t('notes.notifications.fetchUnreadNotesError'))
            throw error
        }
    }

    async fetchUnreadProductionSiteNotesAmount(id) {
        try {
            return await productionSiteNotesQueries.fetchUnreadProductionSiteNotesAmount(id)
        } catch (error) {
            handleApiError(error, t('notes.notifications.fetchUnreadNotesAmountError'))
            throw error
        }
    }
}

export const useProductionSiteNotesService = () => new ProductionSiteNotesService()
